const React = require('react');
const { createElement: h, useState, useMemo } = React;
const WorkbookExplorerPanel = require('./WorkbookExplorerPanel');

function isDescendant(byId, candidateId, ancestorId) {
  if (!candidateId || !ancestorId) return false;
  if (candidateId === ancestorId) return true;
  var current = byId[candidateId];
  while (current && current.parentId) {
    if (current.parentId === ancestorId) return true;
    current = byId[current.parentId];
  }
  return false;
}

function FolderRow(props) {
  var folder = props.folder;
  var depth = props.depth;
  var isSelected = props.isSelected;
  var disabled = props.disabled;
  var onSelect = props.onSelect;
  return h('div', {
    key: folder.id,
    className: 'wbex-row' + (isSelected ? ' wbex-row--selected' : ''),
    style: {
      paddingLeft: (8 + depth * 14) + 'px',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.4 : 1
    },
    onClick: function() { if (!disabled) onSelect(folder.id); }
  },
    h('span', { className: 'wbex-chevron wbex-chevron--placeholder' }),
    h('span', { className: 'wbex-icon' },
      h('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'currentColor' },
        h('path', { d: 'M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V7z' })
      )
    ),
    h('span', { className: 'wbex-label' }, folder.name)
  );
}

function WorkbookMoveToDialog(props) {
  var workbook = props.workbook || { folders: [] };
  var item = props.item || null; // { kind, id }
  var onCancel = props.onCancel || function() {};
  var onConfirm = props.onConfirm || function() {};

  var [selectedFolderId, setSelectedFolderId] = useState('');

  var built = useMemo(function() {
    return WorkbookExplorerPanel.buildFolderTree(workbook.folders);
  }, [workbook.folders]);

  function renderFolder(folder, depth, rows) {
    var disabled = false;
    if (item && item.kind === 'folder') {
      disabled = isDescendant(built.byId, folder.id, item.id);
    }
    rows.push(h(FolderRow, {
      key: folder.id,
      folder: folder,
      depth: depth,
      isSelected: selectedFolderId === folder.id,
      disabled: disabled,
      onSelect: setSelectedFolderId
    }));
    folder.children.forEach(function(child) { renderFolder(child, depth + 1, rows); });
  }

  var rows = [];
  // Workbook root option
  rows.push(h('div', {
    key: '__root__',
    className: 'wbex-row' + (selectedFolderId === '' ? ' wbex-row--selected' : ''),
    style: { paddingLeft: '8px' },
    onClick: function() { setSelectedFolderId(''); }
  },
    h('span', { className: 'wbex-chevron wbex-chevron--placeholder' }),
    h('span', { className: 'wbex-icon' },
      h('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'currentColor' },
        h('path', { d: 'M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V7z' })
      )
    ),
    h('span', { className: 'wbex-label' }, '/ (playbook root)')
  ));
  built.roots.forEach(function(folder) { renderFolder(folder, 1, rows); });

  return h('div', {
    style: {
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100
    },
    onClick: onCancel
  },
    h('div', {
      onClick: function(e) { e.stopPropagation(); },
      style: {
        width: '420px', maxHeight: '70vh', display: 'flex', flexDirection: 'column',
        background: '#1f2330', color: '#d8def0', borderRadius: '8px',
        border: '1px solid #2b3142', boxShadow: '0 12px 32px rgba(0,0,0,0.5)'
      }
    },
      h('div', {
        style: { padding: '14px 16px', borderBottom: '1px solid #2b3142', fontWeight: 600 }
      }, 'Move to…'),
      h('div', {
        className: 'wbex-tree',
        style: { flex: 1, overflow: 'auto', maxHeight: '50vh' }
      }, rows),
      h('div', {
        style: { padding: '12px 16px', borderTop: '1px solid #2b3142', display: 'flex', justifyContent: 'flex-end', gap: '8px' }
      },
        h('button', {
          type: 'button',
          onClick: onCancel,
          style: {
            background: 'transparent', color: '#d8def0',
            border: '1px solid #3a4258', padding: '6px 14px', borderRadius: '6px', cursor: 'pointer'
          }
        }, 'Cancel'),
        h('button', {
          type: 'button',
          onClick: function() { onConfirm(selectedFolderId || ''); },
          style: {
            background: '#4f6ab3', color: '#ffffff',
            border: 'none', padding: '6px 16px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600
          }
        }, 'Move')
      )
    )
  );
}

module.exports = WorkbookMoveToDialog;
